import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import AttributeCodebookForm from "./AttributeCodebookForm";
import { Modal } from "antd";

export interface State {}

export interface CreateCodebookFormProps extends FormComponentProps {
  translate: TTranslate;
  attributeModalVisible: boolean;
  onChangeAttributeModalVisible: (visible: boolean) => void;
  registerFormSubmitEventHandler: any;
}

class CreateCodebookForm extends React.Component<
  CreateCodebookFormProps,
  State
> {
  handleCreate = () => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.registerFormSubmitEventHandler(values);
      this.props.onChangeAttributeModalVisible(false);
    });
  };

  render() {
    const {
      translate,
      attributeModalVisible,
      onChangeAttributeModalVisible
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        title={translate("attribute_codebook.new_codebook")}
        visible={attributeModalVisible}
        onCancel={() => onChangeAttributeModalVisible(false)}
        okText={translate("modal_functions.insert_modal.add")}
        cancelText={translate("modal_functions.insert_modal.cancel")}
        onOk={this.handleCreate}
      >
        <AttributeCodebookForm
          getFieldDecorator={getFieldDecorator}
          translate={translate}
          addNewCodebook
        />
      </Modal>
    );
  }
}

export default CreateCodebookForm;
